import { render, staticRenderFns } from "./AdvertiseAuth.vue?vue&type=template&id=1556535a&scoped=true"
import script from "./AdvertiseAuth.vue?vue&type=script&lang=js"
export * from "./AdvertiseAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1556535a",
  null
  
)

export default component.exports